import { z } from 'zod'

import { RoleType } from '../enums'

export const roleSchema = z.object({
  id: z.string().uuid(),
  workspaceId: z.string().uuid(),
  name: z.string(),
  roleType: z.nativeEnum(RoleType),
  description: z.string().nullable(),
  active: z.boolean(),
})

export const createRoleRequestSchema = z.object({
  name: z.string().min(1),
  description: z.string().nullable().optional(),
  roleType: z.nativeEnum(RoleType),
})

export const updateRoleRequestSchema = z.object({
  name: z.string().min(1),
  description: z.string().nullable().optional(),
})

export const permissionScopeSchema = z.enum([
  'GLOBAL',
  'NODE',
  'SUBTREE',
  'GROUP_NODE',
  'GROUP_SUBTREE',
])

export const permissionSchema = z.object({
  id: z.string().uuid(),
  permissionKey: z.string(),
  resourceType: z.string().nullable(),
  resourceId: z.string().uuid().nullable(),
  scope: permissionScopeSchema.nullable().optional(),
})

export const grantPermissionRequestSchema = z.object({
  granteeRoleId: z.string().uuid().nullable().optional(),
  granteeUserId: z.string().uuid().nullable().optional(),
  permissionKey: z.string(),
  resourceType: z.string().nullable().optional(),
  resourceId: z.string().uuid().nullable().optional(),
  scope: permissionScopeSchema.nullable().optional(),
})

export const replacePermissionsRequestSchema = z.object({
  permissions: z.array(
    z.object({
      permissionKey: z.string(),
      resourceType: z.string().nullable().optional(),
      resourceId: z.string().uuid().nullable().optional(),
      scope: permissionScopeSchema.nullable().optional(),
    })
  ),
})

export type Role = z.infer<typeof roleSchema>
export type CreateRoleRequest = z.infer<typeof createRoleRequestSchema>
export type UpdateRoleRequest = z.infer<typeof updateRoleRequestSchema>
export type Permission = z.infer<typeof permissionSchema>
export type GrantPermissionRequest = z.infer<typeof grantPermissionRequestSchema>
export type ReplacePermissionsRequest = z.infer<typeof replacePermissionsRequestSchema>